module.exports = __webpack_public_path__ + "img/ic-3.6a0bf23.svg";